import { render, staticRenderFns } from "./TopicContentIndex.vue?vue&type=template&id=908a0f7e"
import script from "./TopicContentIndex.vue?vue&type=script&lang=js"
export * from "./TopicContentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports